export const state = {
  client: null,
  estate: null,
	clients: null
}



// WEBPACK FOOTER //
// ./src/store/modules/Clients/state.js